module.exports = __webpack_public_path__ + "static/media/regedit_205.a407993f.ico";